module.exports = __webpack_public_path__ + "static/media/fg-right-palm.7e365f39.svg";